<template>
  <div class="col-lg-12">
    <div class="main-card mb-3 card">
      <div class="card-body">
        <h5 class="card-title">미국학습</h5>
        <!--<div class="sub_title">학습관리->진도/숙제 관리->미국학습</div>-->

        <div class="col-lg-6 offset-lg-3 search_box">
          <table class="table">
            <tr>
              <td>선택검색</td>
              <td>
                <div class="input-group mb-12">
                  <div class="input-group-prepend">
                    <select
                      class="custom-select flex_center"
                      id="inputGroupSelect01"
                    >
                      <option selected>캠퍼스</option>
                      <option value="1">캠퍼스1</option>
                      <option value="2">캠퍼스2</option>
                    </select>
                  </div>
                </div>
              </td>
              <td>
                <div class="input-group mb-12">
                  <div class="input-group-prepend">
                    <select
                      class="custom-select flex_center"
                      id="inputGroupSelect01"
                    >
                      <option selected>담당교사</option>
                      <option value="1">교사1</option>
                      <option value="2">교사2</option>
                    </select>
                  </div>
                </div>
              </td>
              <td>
                <div class="input-group mb-12">
                  <div class="input-group-prepend">
                    <select
                      class="custom-select flex_center"
                      id="inputGroupSelect01"
                    >
                      <option selected>클래스</option>
                      <option value="1">클래스1</option>
                      <option value="2">클래스2</option>
                    </select>
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td>날짜검색</td>
              <td>
                <div class="input-group mb-12">
                  <div class="input-group-prepend">
                    <select
                      class="custom-select flex_center"
                      id="inputGroupSelect01"
                    >
                      <option selected>검색값 선택</option>
                      <option value="1">사용</option>
                      <option value="2">미사용</option>
                    </select>
                  </div>
                </div>
              </td>
              <td>
                <div class="input-group mb-12">
                  <div class="input-group-prepend">
                    <input type="date" class="input_text" />
                  </div>
                </div>
              </td>
              <td>
                <div class="input-group mb-12">
                  <div class="input-group-prepend">
                    <input type="date" class="input_text" />
                  </div>
                </div>
              </td>
            </tr>

            <tr>
              <td>키워드검색</td>
              <td>
                <div class="input-group mb-12">
                  <div class="input-group-prepend">
                    <select
                      class="custom-select flex_center"
                      id="inputGroupSelect01"
                    >
                      <option selected>검색값 선택</option>
                      <option value="1">상품명</option>
                      <option value="2">판매기간</option>
                    </select>
                  </div>
                </div>
              </td>
              <td colspan="2">
                <div class="input-group mb-12">
                  <div class="input-group-prepend">
                    <input type="text" class="input_text" />
                  </div>
                </div>
              </td>
            </tr>
          </table>
        </div>
        <div class="flex_center">
          <!-- Modal -->
          <div
            class="modal fade"
            id="exampleModal"
            tabindex="-1"
            role="dialog"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
          >
            <div class="modal-dialog" role="document">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title" id="exampleModalLabel">
                    Modal title
                  </h5>
                  <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body">
                  <p class="mb-0">
                    Lorem Ipsum has been the industry's standard dummy text ever
                    since the 1500s, when an unknown printer took a galley of
                    type and scrambled.
                  </p>
                </div>
                <div class="modal-footer">
                  <button
                    type="button"
                    class="btn btn-secondary"
                    data-dismiss="modal"
                  >
                    Close
                  </button>
                  <button type="button" class="btn btn-primary">
                    Save changes
                  </button>
                </div>
              </div>
            </div>
          </div>

          <!-- Large modal -->

          <div
            class="modal fade bd-example-modal-lg"
            tabindex="-1"
            role="dialog"
            aria-labelledby="myLargeModalLabel"
            aria-hidden="true"
          >
            <div class="modal-dialog modal-lg">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title" id="exampleModalLongTitle">
                    숙제부여
                  </h5>
                </div>

                <div class="modal-body">
                  <table class="table">
                    <tr>
                      <td>
                        <div
                          class="input-group"
                          style="width: 120px; display: inline-to-blcok"
                        >
                          <div class="input-group-prepend">
                            <select
                              class="custom-select flex_center"
                              id="inputGroupSelect01"
                            >
                              <option selected>CLASS</option>
                              <option value="1">로제반</option>
                              <option value="2">제니반</option>
                            </select>
                          </div>
                        </div>
                      </td>
                      <td>
                        <div
                          class="input-group"
                          style="width: 120px; display: inline-to-blcok"
                        >
                          <div class="input-group-prepend">
                            <select
                              class="custom-select flex_center"
                              id="inputGroupSelect01"
                            >
                              <option selected>ALL</option>
                              <option value="1">개인별</option>
                            </select>
                          </div>
                        </div>
                      </td>
                      <td style="width: 44%"></td>
                      <td>
                        <button class="btn btn-warning btn-sm">GUIDE</button>
                        <button class="btn btn-info btn-sm">
                          FIND ACTIVITY
                        </button>
                      </td>
                    </tr>
                  </table>
                  <!-- 개인별 선택시 -->
                  <p>숙제부여 대상(개인별 부여)</p>
                  <div class="select_homework">
                    <ul>
                      <li>
                        <input type="checkbox" id="homework" /><label
                          for="homework"
                        ></label
                        >김대만
                      </li>
                      <li><input type="checkbox" />김대만</li>
                      <li><input type="checkbox" />김대만</li>
                      <li><input type="checkbox" />김대만</li>
                      <li><input type="checkbox" />김대만</li>
                      <li><input type="checkbox" />김대만</li>
                      <li><input type="checkbox" />김대만</li>
                      <li><input type="checkbox" />김대만</li>
                      <li><input type="checkbox" />김대만</li>
                      <li><input type="checkbox" />김대만</li>
                      <li><input type="checkbox" />김대만</li>
                      <li><input type="checkbox" />김대만</li>
                      <li><input type="checkbox" />김대만</li>
                      <li><input type="checkbox" />김대만</li>
                    </ul>
                  </div>
                  <table class="table">
                    <tbody>
                      <tr>
                        <td class="th_bg">시작일</td>
                        <td><input Type="date" /></td>
                        <td class="th_bg">종료일</td>
                        <td>
                          <input Type="date" />
                        </td>
                      </tr>
                      <tr>
                        <td class="th_bg">부여할 학습</td>
                        <td colspan="3">
                          KR002,KR005,<input
                            type="text"
                            style="width: 100px"
                          /><button class="btn btn-primary btn-sm">추가</button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div class="modal-footer flex_center">
                  <button type="button" class="btn btn-primary">
                    숙제부여
                  </button>
                  <button
                    type="button"
                    class="btn btn-secondary"
                    data-dismiss="modal"
                  >
                    닫기
                  </button>
                </div>
              </div>
            </div>
          </div>
          <button class="btn btn-secondary">조회</button>
          <button
            class="btn btn-danger"
            data-toggle="modal"
            data-target=".bd-example-modal-lg"
          >
            미국 숙제부여
          </button>
        </div>
        <table class="table">
          <thead>
            <tr>
              <th scope="col"><input type="checkbox" disabled checked /></th>
              <th scope="col">#</th>
              <th scope="col">Class</th>
              <th scope="col">Name</th>
              <th scope="col">Due date</th>
              <th scope="col">Grade</th>
              <th scope="col">Course</th>
              <th scope="col">Step</th>
              <th scope="col">Subject</th>
              <th scope="col">Week Activity</th>
              <th scope="col">Complete</th>
              <th scope="col">Total</th>
              <th scope="col">Detail</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="record in records" v-bind:key="record.id">
              <td><input type="checkbox" /></td>
              <th scope="row">{{ record.id }}</th>
              <td>Green1</td>
              <td>유란희</td>
              <td>22-01-27</td>
              <td>MYPATH 1</td>
              <td></td>
              <td></td>
              <td>LA</td>
              <td>LA259</td>
              <td>80%</td>
              <td>35/36</td>
              <td><button class="btn btn-warning btn-sm">상세</button></td>
            </tr>
          </tbody>
        </table>
        {{ this.records }}
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

import Tree from "../components/Tree";
import axios from "axios";
export default {
  name: "Home",
  components: {
    Tree,
  },
  mounted() {
    this.search();
  },
  methods: {
    search() {
      axios.get("/studies/american").then((response) => {
        if (response.data.error) {
          $.notify(
            {
              // options
              message: "데이터를 조회할 수 없습니다. " + response.data.error,
            },
            {
              // settings
              type: "danger",
              z_index: 9999,
            }
          );
        } else {
          this.records = response.data.result;
        }
      });
    },
  },
  data() {
    return {
      records: [],
    };
  },
};
</script>
